import React, { useState, useEffect, useContext } from 'react';
import { Detail as DetailComponent, Confirm, useDrawer, SplitButton, Button } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { useTranslation } from 'react-i18next';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { useLoadOne } from "src/mtska-frontend-data-provider/hooks/useLoadOne.hooks";
import {
    getAuthUserCacheKey,
    getUserConfigCacheKey,
    hashToken,
    removeCache,
} from 'src/mtska-frontend-app-component/utils/cacheTtl';

const dataProviderName = 'auth/user';

function tokenFromImpersonatePayload(apiBody) {
    if (!apiBody) return null;
    if (typeof apiBody.token === 'string' && apiBody.token.length > 0) return apiBody.token;
    if (typeof apiBody.data?.token === 'string' && apiBody.data.token.length > 0) return apiBody.data.token;
    const inner = apiBody.item?.data ?? apiBody.item;
    if (inner && typeof inner.token === 'string' && inner.token.length > 0) return inner.token;
    return null;
}

const Detail = (params) => {
    const { t } = useTranslation();
    const { activate, close: closeDrawer } = useDrawer();
    const { userCapabilities, existingModules } = useContext(AppContext);

    // DATA PROVIDER
    const { item, save, loadOne, destroy, errorMessage, errors, saving, success, reloadCounter, doAction } = useDataProvider(dataProviderName, params.multipart);

    const { modelName, detailConfig } = existingModules[dataProviderName]

    useLoadOne({ loadOne, params, reloadCounter })

    const [editing, setEditing] = useState(false)

    const handleSave = (data) => {
        save({ ...data, filters: params.filters }).then((data) => params.handleClose(params.uid, data.item.data)).catch(() => console.error('catch handleSave'));
    }

    const handleImpersonate = (role) => {
        doAction && doAction({
            action: 'impersonate', model: 'auth/user', data: {
                impersonated_id: item?.data?._id,
                role_id: role._id,
            }
        }).then((dispatchedAction) => {
            const prevToken = localStorage.getItem('token');
            if (prevToken) {
                const h = hashToken(prevToken);
                removeCache(getAuthUserCacheKey(h));
                removeCache(getUserConfigCacheKey(h));
            }
            const apiBody = dispatchedAction?.item;
            const nextToken = tokenFromImpersonatePayload(apiBody);
            if (nextToken) {
                localStorage.setItem('token', nextToken);
            }
            const homeQs = new URLSearchParams();
            const rolePath =
                typeof role?.loggedHomePage === 'string'
                    ? role.loggedHomePage
                    : typeof role?.logged_home_page === 'string'
                        ? role.logged_home_page
                        : '';
            if (rolePath.trim()) {
                homeQs.set('homePath', rolePath.trim());
            } else if (role?.name) {
                homeQs.set('homeRole', String(role.name).trim());
            }
            const q = homeQs.toString();
            window.location.href = q ? `/?${q}` : '/';
        });
    }

    const getImpersonateActions = () => {
        let options = [];

        if (Array.isArray(item?.data?.roles)) {
            item?.data?.roles?.map((role) => {
                options.push({
                    disabled: userCapabilities && !userCapabilities[dataProviderName + '.impersonate'],
                    icon: "faPerson",
                    label: t('Impersonate as {{role}}', { role: role.name }),
                    onClick: () => handleImpersonate(role)
                })
            })
        }

        return options;
    }


    const [confirmCleanSettings, setConfirmCleanSettings] = useState();
    const handleCleanSettings = (id) => {
        setConfirmCleanSettings(
            <Confirm
                oklabel={t("Clean")}
                okcallable={() => {
                    doAction({
                        action:'cleanSettings',
                        model:dataProviderName,
                        data:{ id:id }
                    }).then(() => closeDrawer());
                }}
                kolabel={t("Cancel")}
                kocallable={() => { setConfirmCleanSettings(null) }}
                title={t("Clean settings")}>
                {t("Are you sure to clean the settings for this user?")}
            </Confirm>
        );
    }

    return (
        <>
            <DetailComponent
                disableDetailConfigOverride={true}
                values={{ ...item?.data }}
                modelName={modelName}
                detailConfig={detailConfig}
                dataProviderName={dataProviderName}
                onEditing={setEditing}
                save={handleSave}
                saving={saving}
                errors={errors}
                errorMessage={errorMessage}
                canSave={userCapabilities && userCapabilities[dataProviderName + '.edit']}
                title={item?.data?.email ? item?.data?.email : t('New user')}
                rightButtons={[
                    <SplitButton
                        actions={[

                            {
                                disabled: (userCapabilities && !userCapabilities[dataProviderName + '.deletesettings']),
                                icon: "faTrashCanXmark",
                                label: t('Clean settings'),
                                onClick: () => { handleCleanSettings(item.data.id) }
                            },

                            ...getImpersonateActions(),
                            {
                                disabled: userCapabilities && !userCapabilities[dataProviderName + '.log'],
                                icon: "faClipboardList",
                                label: t('Log'),
                                onClick: () => {
                                    activate('wizards/log', {
                                        model: dataProviderName,
                                        entityId: item.data.id,
                                        detailStack: params.detailStack ?? {},
                                        title: t("Clean settings")
                                    });
                                }
                            },

                        ]}
                    />
                ]}
                {...params}
            />
            {confirmCleanSettings}
        </>
    )
}

export default Detail;


